import styled from 'styled-components';

export const SalesListingsContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const ListingsListContainer = styled.div`
    align-items: start;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const ListingsList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
    width: 100%;
`;

export const EmptyState = styled.div`
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    border: 1px dashed rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    text-align: center;
    min-height: 180px;
    width: 100%;

    h2 {
        color: rgba(255, 255, 255, 0.8);
        font-size: 20px;
        margin: 0;
    }

    p {
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
        margin: 0;
    }
`;

